import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import MembershipSettingPresenter from '../../../../presenters/MembershipSettingPresenter';
import ListSkeleton from '../../../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../pages/constants';
import { useFetchStatus } from '../../../../utils/fetchStatusUtils';

import MembershipSetting from './components/MembershipSetting';

const MembershipSettingsTable = (props) => {
  const {
    membershipSettings,
    loadingState,
    onDeleteClick,
    onEditMembershipSetting,
  } = props;

  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  const isMembershipSettingsEmpty = isEmpty(membershipSettings);

  if (isMembershipSettingsEmpty) {
    return <div className="empty-table">No Membership settings</div>;
  }

  return (
    <div>
      <table className="tables">
        <thead>
          <tr>
            <th>Setting type</th>
            <th>Description</th>
            <th>Value</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {membershipSettings.map((membershipSetting) => {
            return (
              <MembershipSetting
                key={membershipSetting.id}
                membershipSetting={membershipSetting}
                onDeleteClick={onDeleteClick}
                onEditMembershipSetting={onEditMembershipSetting}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MembershipSettingsTable;

MembershipSettingsTable.propTypes = {
  membershipSettings: PropTypes.arrayOf(MembershipSettingPresenter.shape()),
  loadingState: PropTypes.string.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onEditMembershipSetting: PropTypes.func.isRequired,
};

MembershipSettingsTable.defaultProps = {
  membershipSettings: [],
};
